import { FC } from 'react';
import { Button } from '../../../shared/Button';
import { Icon } from '../../../shared/Icon';
import { Heading } from '../../../shared/Heading';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';

interface ViewAllGamesGridErrorProps {
  error: string;
  categoryName: string;
  onRetry?: () => void;
}

export const ViewAllGamesGridError: FC<ViewAllGamesGridErrorProps> = ({ error, categoryName, onRetry }) => {
  const { t } = useTranslations();

  return (
    <div className="view-all-games-grid__error" data-testid="view-all-games-grid-error">
      <div className="view-all-games-grid__error-content">
        <div className="view-all-games-grid__error-icon">
          <Icon variant="Warning" />
        </div>

        <Heading level={3} className="view-all-games-grid__error-title">
          {t('game.carousel.error.unable-to-load', { categoryName })}
        </Heading>

        <p className="view-all-games-grid__error-message">{error}</p>

        <div className="view-all-games-grid__error-actions">
          {onRetry && (
            <Button type="button" variant="primary" onClick={onRetry} className="view-all-games-grid__error-retry">
              <Icon variant="Reload" />
              {t('game.carousel.error.try-again')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
